module.exports = __webpack_public_path__ + "static/img/en.80ae986c.png";